import { Box, Stack } from "@mui/material";
import React from "react";
import { useMutationQueue } from "../../../../service/queryHooks/campaignBookings/mutations/useMutationQueue";
import { LinearProgress } from "../atoms/LinearProgress";
import { SnackbarBlock } from "./snackbars/SnackbarBlock";

export const MutationQueueStatus: React.FC = () => {
  const { state } = useMutationQueue();

  if (state.queueLength === 0) {
    return null;
  }

  const queueText =
    state.queueLength === 1
      ? `Pending ${state.queueLength} update`
      : `Pending ${state.queueLength} updates`;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 16,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1400,
      }}
    >
      <SnackbarBlock
        message={
          <Stack spacing={1}>
            <span style={{ fontSize: "1.5rem" }}>Saving your changes</span>
            <span style={{ fontSize: "1.25rem" }}>{queueText}</span>
            <Stack direction="row" spacing={2} alignItems="center">
              <span style={{ fontSize: "1rem" }}>
                Please wait while your updates are being saved to the campaign
              </span>
              <LinearProgress sx={{ width: 100 }} />
            </Stack>
          </Stack>
        }
        severity="info"
      />
    </Box>
  );
};
